<template>
    <div>
        <AppHeader class="mb-15"/>
        <div class="container">
            <!--            <v-card-actions>-->
            <!--                <v-btn v-if="auth" color="third" class="white&#45;&#45;text" @click="signout">Sign Out</v-btn>-->
            <!--            </v-card-actions>-->
            <v-card-title>Was ist Sales 4.0?</v-card-title>
            <v-card-text>
                Digitalisierung Vertrieb oder kurz gesagt: Sales 4.0.
                <b>Schaffen Sie eine Verknüpfung von Online- und Offline-Vertriebsaktivitäten.</b> Der
                Kundenfokus ist dabei zentral. Vermitteln Sie den Mehrwert Ihres Produkts intelligent und
                anschaulich. Identifizieren Sie die Kundenbedürfnisse und erfüllen Sie diese über digitale Wege.
                In unserem Kaufverhalten hat sich einiges verändert. Menschen treffen Kaufentscheidungen zu 70%
                bevor sie Kontakt zur Vertriebsabteilung aufnehmen. Auf diese Veränderungen muss der Vertrieb in
                Unternehmen reagieren. Stellt sich die Frage: wie? Die Antwort ist: Sales 4.0!
            </v-card-text>
            <v-card-title>Wie kann man von Sales 4.0 profitieren?</v-card-title>
            <v-card-text>
                Digitale Vertriebsaktivitäten garantieren einen detaillierten Überblick über den Sales-Prozess.
                Nutzen Sie neue Potentiale in allen Phasen des Kaufprozesses. Durch die intelligente Verwendung
                von Daten und Informationen schaffen sie
                <b>mehr Transparenz, eine effizientere Kundenakquise, höhere Abschlussraten,
                    Ressourceneinsparungen und weitere zentrale Erfolgsfaktoren.</b>
            </v-card-text>
        </div>
        <AppEmailForm class="mt-15 mb-15"/>
        <div class="container">
            <v-card-title>Der Aufbau der Datenbank</v-card-title>
            <v-card-text>Neue Themen, tausend Informationen und keine konkrete Idee, wie man das im eigenen
                Unternehmen umsetzen kann? So ging es uns bei diesem Thema. Sales 4.0 hat so viele Facetten,
                sodass es manchmal schwierig erscheint, die richtigen und für sich passenden Ansätze zu finden.
                Aus diesem Grund erarbeiten wir das Thema anhand eines praktischen Ansatzes und konkreter
                Implementierungsmöglichkeiten.
            </v-card-text>
        </div>
        <AppModules/>
        <AppEmailForm class="mt-15 mb-15"/>
        <div class="container">
            <v-card-title>Unser Podcast zum Thema Sales 4.0</v-card-title>
            <v-card-text>Wir sprechen über Erfahrungen und konkrete Handlungsempfehlungen im Podcast - hören Sie rein
                und tauchen Sie ein in eine Welt des digitalen Vertriebs. Wir gehen auf Chancen, Möglichkeiten und
                Risiken ein. Erfahren Sie, wie wir unseren Vertrieb sukzessiv umgestalten.
            </v-card-text>
            <AppPodcast class="my-15"/>
        </div>
    </div>
</template>

<script>
    import firebase from "firebase";
    import AppEmailForm from "./AppEmailForm";
    import AppModules from "./AppModules";
    import AppPodcast from "./AppPodcast";
    import AppHeader from "./AppHeader";

    export default {
        data: () => ({
            auth: null,
        }),
        components: {
            AppEmailForm,
            AppModules,
            AppPodcast,
            AppHeader,
        },
        mounted() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.auth = true;
                    // console.log("IN");
                } else {
                    this.auth = false;
                    // console.log("OUT");
                }
            });
        },
        methods: {
            // signout() {
            //     firebase.auth().signOut();
            //     // .then(() => console.log("singed out"));
            // },
        },
        computed: {
            title() {
                return this.text;
            },
        },
    };
</script>

<style scoped>
    * {
        font-family: "Montserrat", sans-serif;
    }

    .container {
        width: 100%;
    }

    h1 {
        text-align: center;
        vertical-align: middle;
    }

    .logo img {
        width: 150px;
        padding: 20px;
    }

    @media only screen and (min-width: 992px) {
        .container {
            width: 80% !important;
        }
    }

    @media only screen and (min-width: 370px) {

    }
</style>
